import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";
const { background, grey } = colors;
const { borderRadius } = borders;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: background.paper,
      backgroundClip: "border-box",
      border: `1px solid ${grey[200]}`,
      borderRadius: borderRadius.xl,
      boxShadow: boxShadows.sm,
      overflow: "visible",
    },
  },
};

export default card;
